import React, { FC } from "react";

interface SignupType {
    img: string;
    content: string;
    btn: string;
}

const Signup: FC<SignupType> = ({ img, content, btn }) => {
    return (
        <section className="bg-blue-color stroke-pattern mt-10">
            <div className="max-w-6xl mx-auto signup flex flex-col sm:flex-row gap-8 sm:gap-1 items-center justify-between p-7">
                <div className="flex gap-4 items-center justify-center">
                    <img src={img} alt="" />
                    <p className="text-white">{content}</p>
                </div>
                <div>
                    <a href="https://app.gallabox.com/signup" className="jsx-1957620388 signup-btn text-blue-color bg-white p-4">
                        {btn}
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Signup;
